import moment from "moment";
import React from "react";
import { useNavigate } from "react-router-dom";

const FieldForceVersionTableData = ({ data, index, currentPage }) => {
  const navigate = useNavigate();

  return (
    <tr className="table-rows1" key={index}>
      <td className="table-each-row-data">
        {(currentPage - 1) * 10 + (index + 1)}{" "}
      </td>
      <td className="table-each-row-data">{data?.user_id}</td>
      <td className="table-each-row-data">{data?.employee_id}</td>
      <td className="table-each-row-data">{data?.name}</td>
      <td className="table-each-row-data">
        {data?.fieldForceDesignation?.name}
      </td>
      <td className="table-each-row-data">
        {data?.fieldForceUserHeadQuaters?.map((e, index) => {
          return (
            <span>
              {index ? ", " : ""}
              {e?.headQuater?.name}
            </span>
          );
        })}
      </td>
      {/* <td className="table-each-row-data">{data?.vendorDivision?.name}</td> */}
      <td className="table-each-row-data">{data.fieldForceDivisions?.length > 0
        ? data.fieldForceDivisions?.map((ele, index) => {
          return (
            <span className="slice-word" key={index}>
              <span style={{ color: "#B0B3C7" }}>{index ? " | " : ""}</span>
              {ele?.vendorDivision?.name ? ele?.vendorDivision?.name : "--"}
            </span>
          );
        })
        : data?.vendorDivision?.name ? data?.vendorDivision?.name : "--"}</td>
      {data.status ? (
        <td className="table-each-row-data color-green">Active</td>
      ) : (
        <td className="table-each-row-data color-danger">Inactive</td>
      )}
      <td className="table-each-row-data">
        {data?.fieldForceUserVersion?.updatedBy?.name}
      </td>
      <td className="table-each-row-data">
        {moment(data?.fieldForceUserVersion?.updatedAt).format(
          "DD MMM YYYY HH:mm A"
        )}
      </td>
      <td className="table-each-row-data">
        <div className="all-button">
          <button
            className="button-view"
            type="button"
            onClick={() =>
              navigate(`/field-force/user/version-history-detail/${data?.id}`)
            }
          >
            View
          </button>
        </div>
      </td>
    </tr>
  );
};

export default FieldForceVersionTableData;
